// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select[data-v-597cad9c] .el-select__tags > span {\n  width: 100%;\n  box-sizing: border-box;\n  padding-left: 10px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.el-select[data-v-597cad9c] .el-select__tags > span span {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n", ""]);
// Exports
module.exports = exports;
